import React from 'react';
import type { FC } from 'react';

import type { TConfirmation } from './models';

// istanbul ignore next
const foo = () => {};

export const Confirmation: FC<TConfirmation> = ({
    CoreConfirmation,
    className,
    onChangeScreen = foo,
    onChangeState = foo,
    onInputFinished = foo,
    onSmsRetryClick = foo,
    errorVisibleDuration = 300,
    ...props
}) => {
    return (
        <CoreConfirmation
            {...props}
            className={className}
            errorVisibleDuration={errorVisibleDuration}
            onChangeScreen={onChangeScreen}
            onChangeState={onChangeState}
            onInputFinished={onInputFinished}
            onSmsRetryClick={onSmsRetryClick}
        />
    );
};
